export default {
      id: "arcs_panorama-usage",
      viewBox: "0 0 260 260",
      url: "../dist/images/" + "sprite.svg#arcs_panorama-usage",
      toString: function () {
        return this.url;
      }
    }